import { useMemo, useEffect } from 'react';

interface ImageContentViewerProps {
  data: Uint8Array;
  fileName: string;
  mimeType: string;
}

export function ImageContentViewer({ data, fileName, mimeType }: ImageContentViewerProps) {
  const objectUrl = useMemo(() => {
    if (!data?.length) {
      return null;
    }
    const blob = new Blob([data], { type: mimeType });
    return URL.createObjectURL(blob);
  }, [data, mimeType]);

  useEffect(() => {
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [objectUrl]);

  if (!objectUrl) {
    return (
      <div className="image-content-viewer">
        <div className="image-content-viewer__message">
          <p>Unable to display image</p>
        </div>
      </div>
    );
  }

  return (
    <div className="image-content-viewer">
      <div className="image-content-viewer__canvas">
        <img
          src={objectUrl}
          alt={fileName}
          className="image-content-viewer__image"
          decoding="async"
        />
      </div>
    </div>
  );
}
